(() => {
  const root = document.querySelector('[data-pw-cart-config]');
  if (!root) return;

  const deliveryMethodForMode = value => value === 'pickup' ? 'pickup' : value ? 'delivery' : '';
  let deliverySyncTimer = null;

  async function syncDeliveryMethod(value) {
    const deliveryMethod = deliveryMethodForMode(value);
    if (!deliveryMethod) return;
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: {pw_delivery_method: deliveryMethod}})
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
    } catch (error) {
      console.error('[Paulissen] pw_delivery_method kon niet worden opgeslagen.', error);
    }
  }

  root.addEventListener('change', event => {
    if (!event.target.matches('[data-pw-mode]')) return;
    clearTimeout(deliverySyncTimer);
    deliverySyncTimer = setTimeout(() => syncDeliveryMethod(event.target.value), 80);
  });

  const currentMode = root.querySelector('[data-pw-mode]:checked')?.value || root.dataset.currentMode || '';
  if (currentMode) syncDeliveryMethod(currentMode);

  [...root.querySelectorAll('.pw-choice-card')].forEach(card => {
    const input = card.querySelector('[data-pw-mode]');
    const strong = card.querySelector('strong');
    const small = card.querySelector('small');
    const price = card.querySelector('b');
    if (!input) return;

    if (input.value === 'delivery') {
      if (strong) strong.textContent = 'Alleen bezorgen';
      if (small) small.textContent = 'Bezorgen zonder aansluiten of inbouwen.';
      if (price) {
        price.hidden = false;
        price.textContent = '€20 per bestelling';
      }
    }

    if (input.value === 'install') {
      if (strong) strong.textContent = 'Full service bezorgen';
      if (small) small.textContent = 'Kies hieronder de gewenste installatie- en serviceopties.';
      if (price) {
        price.textContent = '';
        price.hidden = true;
      }
      card.classList.remove('is-disabled');
      input.disabled = false;
    }

    if (input.value === 'pickup') {
      if (strong) strong.textContent = 'Afhalen';
      if (small) small.textContent = 'Gratis afhalen bij Paulissen Witgoed in Tilburg, op afspraak.';
      if (price) {
        price.hidden = false;
        price.textContent = 'Gratis';
      }
    }
  });

  const intro = root.querySelector('.pw-cart-config__top p:last-child');
  if (intro) intro.textContent = 'Kies alleen bezorgen, full service bezorgen of afhalen. Daarna tonen we alleen de opties die bij uw keuze passen.';

  const euro = value => {
    let amount = Number(value || 0);
    if (amount > 1000) amount = amount / 100;
    return new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(amount);
  };

  // Onderbouwen blijft een losse service en is geen inbouwservice.
  [...root.querySelectorAll('[data-pw-install]')].forEach(input => {
    const rawFull = Number(input.dataset.fullPrice || 0);
    const full = rawFull > 1000 ? rawFull / 100 : rawFull;
    if (Math.abs(full - 75) < 0.01) {
      input.removeAttribute('data-pw-install');
      input.dataset.variant = input.dataset.fullVariant || '';
      input.dataset.serviceGroup = 'underbouw';
      input.dataset.serviceTitle = 'Onderbouwen';
      input.checked = false;

      const card = input.closest('.pw-service-option');
      if (card) {
        const strong = card.querySelector('strong');
        const small = card.querySelector('small');
        const price = card.querySelector('b');
        if (strong) strong.textContent = 'Onderbouwen door ons';
        if (small) small.textContent = 'Vrijstaand apparaat passend onder het werkblad plaatsen.';
        if (price) price.textContent = euro(rawFull);
      }
    }
  });

  // Plaatsingsvalidatie: toon de fout direct bij elk apparaat dat nog niet compleet is.
  const placementStyle = document.createElement('style');
  placementStyle.textContent = `
    .pw-placement-row.has-placement-error{outline:2px solid #b20d0d;outline-offset:3px;background:#fff8f8}
    .pw-placement-error{grid-column:2/4;margin:0;padding:8px 10px;border-left:3px solid #b20d0d;background:#fff1f1;color:#8f0b0b;font-size:12px;font-weight:700;line-height:1.4}
    @media(max-width:900px){.pw-placement-error{grid-column:1}}
  `;
  document.head.appendChild(placementStyle);

  const placementDevices = () => [...root.querySelectorAll('[data-pw-placement-device][data-placement-required="true"]')];

  function errorNode(device) {
    let node = device.querySelector('[data-pw-placement-error]');
    if (!node) {
      node = document.createElement('p');
      node.className = 'pw-placement-error';
      node.dataset.pwPlacementError = '';
      node.setAttribute('role', 'alert');
      node.hidden = true;
      device.appendChild(node);
    }
    return node;
  }

  function clearPlacementError(device) {
    if (!device) return;
    device.classList.remove('has-placement-error');
    const node = errorNode(device);
    node.textContent = '';
    node.hidden = true;
  }

  function setPlacementError(device, message) {
    const node = errorNode(device);
    node.textContent = message;
    node.hidden = false;
    device.classList.add('has-placement-error');
  }

  function placementErrorFor(device) {
    const level = device.querySelector('[data-pw-place]:checked')?.value || '';
    if (!level) return 'Kies waar dit apparaat moet komen: begane grond, met lift of via de trap.';
    if (level === 'stairs' && !device.querySelector('[data-pw-floors]')?.value) return 'Kies ook het aantal verdiepingen voor levering via de trap.';
    return '';
  }

  function validatePlacementDevices(revealErrors = false) {
    const selectedMode = root.querySelector('[data-pw-mode]:checked')?.value || '';
    if (!selectedMode || selectedMode === 'pickup') {
      placementDevices().forEach(clearPlacementError);
      return [];
    }

    const invalid = [];
    placementDevices().forEach(device => {
      const message = placementErrorFor(device);
      if (message) {
        invalid.push(device);
        if (revealErrors) setPlacementError(device, message);
      } else {
        clearPlacementError(device);
      }
    });
    return invalid;
  }

  root.addEventListener('change', event => {
    if (!event.target.matches('[data-pw-place], [data-pw-floors]')) return;
    const device = event.target.closest('[data-pw-placement-device]');
    if (!device) return;
    const message = placementErrorFor(device);
    if (message && device.classList.contains('has-placement-error')) setPlacementError(device, message);
    else if (!message) clearPlacementError(device);
  });

  root.addEventListener('click', event => {
    const nextButton = event.target.closest('[data-pw-next]');
    if (!nextButton) return;
    const step1 = root.querySelector('[data-pw-step="1"]');
    if (!step1?.classList.contains('is-active')) return;

    const selectedMode = root.querySelector('[data-pw-mode]:checked')?.value || '';
    if (!selectedMode || selectedMode === 'pickup') return;

    const invalid = validatePlacementDevices(true);
    if (!invalid.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const globalStatus = root.querySelector('[data-pw-status]');
    if (globalStatus) {
      globalStatus.textContent = invalid.length === 1
        ? 'Maak eerst de plaatsingskeuze bij het gemarkeerde apparaat compleet.'
        : `Maak eerst de plaatsingskeuzes bij de ${invalid.length} gemarkeerde apparaten compleet.`;
      globalStatus.classList.add('is-error');
    }

    invalid[0].scrollIntoView({behavior:'smooth', block:'center'});
    const firstChoice = invalid[0].querySelector('[data-pw-place], [data-pw-floors]');
    if (firstChoice) window.setTimeout(() => firstChoice.focus({preventScroll:true}), 350);
  }, true);

  // Leesbare plaatsingsgegevens voor order, kantoor en notificaties.
  let readablePlacementTimer = null;
  let readablePlacementBusy = false;

  function placementLabel(device) {
    const level = device.querySelector('[data-pw-place]:checked')?.value || '';
    const floors = device.querySelector('[data-pw-floors]')?.value || '';
    if (level === 'ground') return 'Begane grond';
    if (level === 'lift') return 'Verdieping met lift';
    if (level === 'stairs') {
      if (floors === '1') return 'Via trap · 1 verdieping';
      if (floors === '2') return 'Via trap · 2 verdiepingen';
      if (floors === '3+') return 'Via trap · 3 of meer verdiepingen';
      return 'Via trap';
    }
    return '';
  }

  async function syncReadablePlacements() {
    if (readablePlacementBusy) return;
    readablePlacementBusy = true;
    try {
      const cartResponse = await fetch('/cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!cartResponse.ok) throw new Error(`HTTP ${cartResponse.status}`);
      const cart = await cartResponse.json();
      const attributes = {};

      Object.keys(cart.attributes || {}).forEach(key => {
        if (/^Plaatsing apparaat \d+$/.test(key)) attributes[key] = '';
      });

      const selectedMode = root.querySelector('[data-pw-mode]:checked')?.value || root.dataset.currentMode || '';
      if (selectedMode && selectedMode !== 'pickup') {
        placementDevices().forEach((device, index) => {
          const label = placementLabel(device);
          if (!label) return;
          const title = String(device.dataset.title || `Apparaat ${index + 1}`).trim();
          const quantity = Math.max(1, Number(device.dataset.quantity || 1));
          const quantityText = quantity > 1 ? ` × ${quantity}` : '';
          attributes[`Plaatsing apparaat ${index + 1}`] = `${title}${quantityText} — ${label}`;
        });
      }

      if (!Object.keys(attributes).length) return;
      const updateResponse = await fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({attributes})
      });
      if (!updateResponse.ok) throw new Error(`HTTP ${updateResponse.status}`);
    } catch (error) {
      console.error('[Paulissen] Leesbare plaatsingsgegevens konden niet worden opgeslagen.', error);
    } finally {
      readablePlacementBusy = false;
    }
  }

  function queueReadablePlacements(delay = 450) {
    clearTimeout(readablePlacementTimer);
    readablePlacementTimer = setTimeout(syncReadablePlacements, delay);
  }

  root.addEventListener('change', event => {
    if (event.target.matches('[data-pw-mode], [data-pw-place], [data-pw-floors]')) queueReadablePlacements();
  });

  document.addEventListener('on:cart:change', event => {
    if (!event.detail?.cart) return;
    queueReadablePlacements(80);
  });

  // Laat stap 3 pas naar checkout gaan nadat de leesbare plaatsing is opgeslagen.
  root.addEventListener('click', async event => {
    const nextButton = event.target.closest('[data-pw-next]');
    if (!nextButton) return;
    const step3 = root.querySelector('[data-pw-step="3"]');
    if (!step3?.classList.contains('is-active')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    nextButton.disabled = true;
    try {
      await syncReadablePlacements();
      window.location.href = '/checkout';
    } finally {
      nextButton.disabled = false;
    }
  }, true);

  queueReadablePlacements(300);
})();